import { render, staticRenderFns } from "./ServiceItems.vue?vue&type=template&id=e4bf813e"
import script from "./ServiceItems.vue?vue&type=script&lang=js"
export * from "./ServiceItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports